const Layout = () => import("@/layout/index.vue");

export default {
  path: "/billAdmin",
  name: "BillAdmin",
  component: Layout,
  meta: {
    title: "操作页面",
    showLink: false
  },
  children: [
    {
      path: "/billAdmin/options/index",
      name: "BillAdminOptions",
      component: () => import("@/views/billAdmin/options/index.vue"),
      meta: {
        title: "对账单管理操作"
      }
    }
  ]
} satisfies RouteConfigsTable;
